<div class="signup">
  <div class="login-panel">
    <div class="row no-gutters">
      <div class="col-md-1 col-12">
        <div class="left-side"></div>
      </div>
      <div class="col-md-10 col-12">
        <div class="right-side bg-white">
          <div class="login-block">
            <h3 class="head">{{ 'signUp.registerName' | translate }}</h3>
            <mat-radio-group
              *ngIf="!hideRadio"
              aria-label="Select an option"
              name="newOrExisting"
              (change)="showHideNewCustomer($event)"
              [(ngModel)]="newOrExisting">
              <div class="row">
                <div class="col-6">
                  <mat-radio-button value="new">{{ 'signUp.newCustomer' | translate }}</mat-radio-button>
                </div>
                <div class="col-6">
                  <mat-radio-button value="existing">{{ 'signUp.existingCustomer' | translate }}</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
            <form
              class="new-form"
              [formGroup]="newCustomerForm"
              *ngIf="selectNewCustOption"
              (ngSubmit)="regNewCustomer()">
              <input
                type="text"
                placeholder="{{ 'signUp.customerName' | translate }}"
                formControlName="customerName"
                class="form-control mb-2" />

              <input
                type="text"
                placeholder="{{ 'signUp.customerId' | translate }}"
                formControlName="customerId"
                class="form-control mb-1" />

              <mat-form-field class="mt-1" style="font-size: 4px; width: 100%" appearance="none">
                <mat-select
                  disableRipple
                  placeholder="{{ 'signUp.selectCountry' | translate }}"
                  formControlName="customerCountry"
                  class="form-control"
                  (click)="showSearch()"
                  (openedChange)="triggerEvent($event)">
                  <div class="p-2 search-bar-group">
                    <input
                      matInput
                      #search
                      class="pt-2 input-search"
                      placeholder="{{ 'signUp.searchCountry' | translate }}"
                      formControlName="searchTerm"
                      (keyup)="filterBySearch()" />
                  </div>

                  <mat-option *ngFor="let item of listOfCountries" [value]="item">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="font-size: 4px; width: 100%" appearance="none">
                <mat-select
                  disableRipple
                  class="form-control"
                  placeholder="{{ 'signUp.selectProduct' | translate }}"
                  formControlName="productType"
                  multiple>
                  <mat-option
                    *ngFor="let product of productType"
                    [value]="product"
                    selected="true"
                    disabled>
                    {{ product }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="m-2 p-1 rounded">
                <mat-checkbox
                  formControlName="configuration"
                  class="text-wrap"
                  id="checkbox"
                  value="true"
                  disabled>
                  {{ 'signUp.provideDefaultConfiguration' | translate }}
                </mat-checkbox>
              </div>
              <div *ngIf="this.customerRole == 'GLOBAL_ADMIN'" class="m-2 p-1 rounded">
                <mat-checkbox formControlName="cacheActive" class="text-wrap" id="checkboxCache">
                  {{ 'signUp.cacheMechanism' | translate }}
                </mat-checkbox>
              </div>

              <div class="text-center">
                <button type="submit" [disabled]="newCustomerForm.invalid" class="btn btn-login">
                  {{ 'signUp.next' | translate }}
                </button>
              </div>
            </form>

            <form
              *ngIf="!selectNewCustOption && userRegScreenDisplay"
              class="login-form"
              [formGroup]="signupForm"
              (ngSubmit)="signupUser()">
              <mat-form-field class="mt-1" style="font-size: 4px; width: 100%" appearance="none">
                <mat-select
                  disableRipple
                  placeholder="{{ 'signUp.selectCustomerId' | translate }}"
                  formControlName="customerID"
                  class="form-control"
                  (click)="showSearch()"
                  (openedChange)="triggerEvent($event)">
                  <div class="p-2 search-bar-group">
                    <input
                      matInput
                      #search
                      class="pt-2 input-search"
                      placeholder="{{ 'signUp.searchCustomerId' | translate }}"
                      formControlName="searchCustomerID"
                      (keyup)="filterBySearchCustomerIds()" />
                  </div>
                  <mat-option *ngFor="let eachId of customerIDs" [value]="eachId">
                    {{ eachId }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <app-error-component
                [controlName]="signupForm.get('customerID')"></app-error-component>

              <div class="row">
                <div class="col-12 mt-2 mb-3">
                  <!-- <div class="form-group"> -->
                  <input
                    type="email"
                    placeholder="{{ 'signUp.enterEmailId' | translate }}"
                    formControlName="email"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  <app-error-component
                    [controlName]="signupForm.get('email')"></app-error-component>
                </div>
              </div>

              <div class="row">
                <div class="col-6 mb-2">
                  <input
                    type="text"
                    placeholder="{{ 'signUp.firstName' | translate }}"
                    formControlName="firstName"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid': submitted && f.firstName.errors
                    }" />
                  <app-error-component
                    [controlName]="signupForm.get('firstName')"></app-error-component>
                </div>

                <div class="col-6">
                  <input
                    type="text"
                    placeholder="{{ 'signUp.lastName' | translate }}"
                    formControlName="lastName"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid': submitted && f.lastName.errors
                    }" />
                  <app-error-component
                    [controlName]="signupForm.get('lastName')"></app-error-component>
                </div>
              </div>

              <mat-form-field style="font-size: 4px; width: 100%" appearance="none">
                <mat-select
                  disableRipple
                  placeholder="{{ 'signUp.selectProduct' | translate }}"
                  formControlName="productType"
                  class="form-control"
                  multiple>
                  <mat-option *ngFor="let item of productType" [value]="item" disabled>
                    {{ item }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <app-error-component
                [controlName]="signupForm.get('productType')"></app-error-component>

              <mat-form-field style="font-size: 4px; width: 100%" appearance="none">
                <mat-select
                  disableRipple
                  placeholder="{{ 'signUp.selectCountry' | translate }}"
                  formControlName="country"
                  class="form-control"
                  (click)="showSearch()"
                  (openedChange)="triggerEvent($event)">
                  <div class="p-2 search-bar-group">
                    <input
                      matInput
                      #search
                      class="pt-2 input-search"
                      placeholder="{{ 'signUp.searchCountry' | translate }}"
                      formControlName="searchTerm"
                      (keyup)="filterBySearch()" />
                  </div>

                  <mat-option *ngFor="let item of listOfCountries" [value]="item">
                    {{ item.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <app-error-component [controlName]="signupForm.get('country')"></app-error-component>

              <div class="text-center">
                <button type="submit" [disabled]="signupForm.invalid" class="btn btn-login">
                  {{ 'signUp.register' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
